import { APIGenerateTestsResponse } from "./API";
import { SkillType } from "./SkillLevel";

export interface UserResponse {
  test: APIGenerateTestsResponse["tests"][0];
  response: string;
  secondsTaken: number;
}

export interface UserResponseWithXPBreakdown extends UserResponse {
  totalXPEarned: number;
  xpBreakdown: Partial<{
    [skillName in SkillType["name"]]: number;
  }>;
}

export enum AppLevelModalType {
  CreateAccountForFree = "createAccountForFree",
  SignInToLikeResponse = "signInToLikeResponse",
  SignInToBookmarkResponse = "signInToBookmarkResponse",
  Paywall = "paywall",
}
